<template>

    <div class="container">

        <div class="my-4">
            <h1>{{ __('Benutzer bearbeiten') }}</h1>
        </div>

        <div class="row">
            <div class="col-md-6">

                <form @submit.prevent="update">
                    <form-fields :form="form" :user="user" />
                </form>

            </div>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'user',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    _method: 'put',
                    salutation: this.user.salutation,
                    title: this.user.title,
                    first_name: this.user.first_name,
                    last_name: this.user.last_name,
                    email: this.user.email,
                    password: null,
                    password_confirmation: null,
                    avatar: null,
                    notes: this.user.notes,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
            update() {
                this.form.post(this.route('users.update', this.user), {
                    onSuccess: () => this.form.reset('password', 'avatar'),
                });
            }
        },
    }
</script>